export const DEFAULT_CHART_COLORS = [
  '#8884d8',
  '#82ca9d',
  '#ffc658',
  '#ff8042',
  '#0088fe',
];

export function getPalette(override?: string[]) {
  return override && override.length > 0 ? override : DEFAULT_CHART_COLORS;
}
